<template>
  <div class="exam_start flex Flexalign Flexjustify">
    <div class="exam_prompt flex flexcolumn Flexalign" v-if="step == 1">
      <div class="exam_name">{{ (paperType == "testPaper") ? examInfo.paperAppraisalName : examInfo.testName }}</div>
      <div class="exam_prompt_box mt-20 flex flexcolumn Flexalign">
        <div class="prompt_title">请开始考试前确保</div>
        <div class="flex prompt_list FlexBetween">
          <div class="prompt_one flex flexcolumn Flexalign" v-for="(item, index) in promptList" :key="index">
            <el-image class="prompt_image" :src="iconPath(item.icon)"></el-image>
            <div class="mt-20">{{ item.label }}</div>
          </div>
        </div>
        <div class="btn_confirm mt-50 cursor_pointer" @click="nextStep">已确认完成上述事项</div>
      </div>
    </div>
    <div class="exam_prompt flex flexcolumn Flexalign" v-if="step == 2">
      <div class="exam_prompt_box flex flexcolumn Flexalign" style="margin-top: 150px">
        <div class="prompt_title">{{ (paperType == "testPaper") ? examInfo.paperAppraisalName : examInfo.paperName }}
        </div>
        <div class="exam_title mt-30 flex Flexalign">
          <div class="green_line"></div>
          <div class="ml-10">基础信息</div>
        </div>
        <div class="exan_info_one flex">
          考试限时：
          <div class="ml-20 examInfo_value">{{ examInfo.answerTime }}分钟</div>
        </div>
        <div class="flex exan_info_one">
          <!-- <div class="exan_info_one_half flex">
            及格分数：
            <div class="ml-20 examInfo_value">{{ ((paperType == "testPaper") ? examInfo.otherRule.passScoreCondition :
              examInfo.passCondition)?(((paperType == "testPaper") ? examInfo.otherRule.passScoreCondition :
              examInfo.passCondition) + "%"):"无" }}</div>
          </div> -->
          <div class="exan_info_one_half flex">
            试卷总分：
            <div class="ml-20 examInfo_value">{{ (paperType == "testPaper") ? examInfo.totalScore : examInfo.fullScore
              }}分
            </div>
          </div>
        </div>
        <div class="exan_info_one flex">
          试题总数：
          <div class="ml-20 examInfo_value">{{ examInfo.questionCount }}</div>
        </div>
        <div class="exam_title mt-30 flex Flexalign">
          <div class="green_line"></div>
          <div class="ml-10">考试描述</div>
        </div>
        <div class="exan_info_one">
          {{ (paperType == "testPaper") ? examInfo.paperAppraisalDescription : examInfo.testDescription }}
        </div>
        <div class="btn_confirm mt-30 cursor_pointer" @click="beginExam">开始考试</div>
        <div class="btn_prompty mt-20">如考试异常中段，请退出，并及时按同样步骤</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GjkcH5ExamStart",

  data() {
    return {
      step: 1,
      promptList: [
        { icon: "exam_start_icon1.png", label: "上过洗手间" },
        { icon: "exam_start_icon2.png", label: "身边没有人" },
        { icon: "exam_start_icon3.png", label: "房间光线明亮不背光不反光" },
      ],
      examInfo: {
        // time: "90分钟",
        // passScore: "60%",
        // totalScore: "100分",
        // questionNum: 28,
        // desc:
        //   "考察范围：集合与常用逻辑，函数与导数，计数原理与概率统计，竞赛知识点，等式与不等式，平面向量，空间向量与立体几个，平面几何，包含知识点",
      },
      paperInfo: {},
      paperType: '',  // 用于区分是考试还是能力测评
    };
  },

  mounted() {
    this.paperInfo = JSON.parse(this.$Jump.getUrlParams(window.location.hash.split("?")[1]).paperInfo);
    this.paperType = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).paperType;
    // paperType为testPaper是能力测评
    if (this.paperType == 'testPaper') {
      this.getTestPaperInfo();
    } else {
      this.getExamInfo();
    }
  },

  methods: {
    // 考试详情
    getExamInfo() {
      this.$Api.exam.getExamInfo(this.paperInfo.testId).then(res => {
        this.examInfo = res.data.data;
      }).catch(() => { })
    },
    // 测评信息
    getTestPaperInfo() {
      this.$Api.testPaper.getTestPaperInfo(this.paperInfo.paperAppraisalId).then(res => {
        this.examInfo = res.data.data;
        console.log(this.examInfo)
      }).catch(() => { })
    },
    nextStep() {
      this.step = 2;
    },
    // 开始考试
    beginExam() {
      // paperType为testPaper是能力测评
      if (this.paperType == 'testPaper') {
        this.href("/examLogin", { paperInfo: JSON.stringify(this.paperInfo),paperType:this.paperType });
      } else {
        this.href("/examPaper", { paperInfo: JSON.stringify(this.paperInfo) });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.exam_start {
  width: 100vw;
  height: 100vh;
  background: #f3f3f3;

  .exam_prompt {
    width: 1200px;
    min-height: 740px;
    background-image: url("/public/static/icon/exam_start_bg.png");

    .exam_name {
      margin-top: 110px;
      font-size: 18px;
      color: #909090;
    }

    .exam_prompt_box {
      width: 762px;
      min-height: 473px;
      background: #ffffff;
      box-shadow: 0px 7 30px 0px rgba(0, 175, 158, 0.14);
      border-radius: 20px;
      box-sizing: border-box;
      padding: 30px 40px;

      .prompt_title {
        font-size: 18px;
        color: #111111;
      }

      .prompt_list {
        width: 100%;
        font-size: 14px;
        color: #606060;

        .prompt_image {
          margin-top: 40px;
          width: 200px;
          height: 200px;
        }
      }

      .btn_confirm {
        padding: 10px 40px;
        font-size: 16px;
        color: #ffffff;
        background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
        border-radius: 40px;
      }

      .btn_prompty {
        font-size: 14px;
        color: #bfbfbf;
      }

      .exam_title {
        width: 100%;
        font-size: 14px;
        color: #111111;
        font-weight: 600;

        .green_line {
          width: 3px;
          height: 16px;
          background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
          border-radius: 4px;
        }
      }

      .exan_info_one {
        width: 100%;
        font-size: 14px;
        color: #666666;
        margin-top: 20px;

        .examInfo_value {
          color: #111111;
        }

        .exan_info_one_half {
          width: 50%;
        }
      }
    }
  }
}
</style>
